











import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class UiIcon extends Vue {
  @Prop()
  icon: string;

  @Prop()
  color: string;

  @Prop({ default: '13' })
  size: string;

  @Prop({ default: false })
  disabled: boolean;

  get stateDisabled() {
    return this.disabled || (this.$parent as any).disabled
  }

  get styles() {
    return {
      'font-size': `${this.size}px`,
      'color': this.stateDisabled ? this.$colors.gray40 : (this.color || this.$colors.graphite),
    }
  }

}
